export default __webpack_public_path__ + "static/media/Dollar-Bill-Yall-Badge.36a52fd5.gif";